import React, { FC } from 'react'

import { IconDataProps } from './IconData.types'
import * as Styled from './styles/IconData.style'

import { nonThemeableRules } from '../../ruleSet'

const IconData: FC<IconDataProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDataProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconDataProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M159.71 106.51A4 4 0 0 0 156 104h-20V52a4 4 0 0 0-4-4h-26.39L56.77 1.11a4 4 0 0 0-5.54 0l-50 48A4 4 0 0 0 4 56h20v52a4 4 0 0 0 4 4h26.39l48.84 46.89a4 4 0 0 0 5.54 0l50-48a4 4 0 0 0 .94-4.38zM28 48H13.94L54 9.54 94.06 48H80a4 4 0 0 0-4 4v52H32V52a4 4 0 0 0-4-4zm78 102.46L65.94 112H80a4 4 0 0 0 4-4V56h44v52a4 4 0 0 0 4 4h14.06z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconData
